import { handleActions } from 'redux-actions';
import { Report } from 'types';
import {
    DesignerSetReportAction,
    DesignerSaveRequestAction,
    DesignerSaveSuccessAction,
    DesignerSaveFailureAction,
    DesignerCancelAction,
} from 'actions/designerActions';
import { LogoutAction } from 'actions/shellActions';

export type State = Readonly<{
    isNew: boolean;
    report: Readonly<Report> | null;
    saving: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    isNew: true,
    report: null,
    saving: false,
    error: null,
});

export type ReducerAction =
    DesignerSetReportAction
    | DesignerSaveRequestAction
    | DesignerSaveSuccessAction
    | DesignerSaveFailureAction
    | DesignerCancelAction
    // Shell Actions
    | LogoutAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

export const designerReducer: Reducer = handleActions({
    DESIGNER_SET_REPORT(state: State, action: DesignerSetReportAction) {
        // Read the flag from action.meta but default to existing state if the flag was undefined
        const { isNew = state.isNew } = action.meta;
        return {
            ...state,
            report: action.payload,
            isNew,
        };
    },

    DESIGNER_SAVE_REQUEST(state: State, action: DesignerSaveRequestAction) {
        return {
            ...state,
            saving: true,
            error: null,
        };
    },

    DESIGNER_SAVE_SUCCESS(state: State, action: DesignerSaveSuccessAction) {
        return {
            ...state,
            saving: false,
            error: null,
            isNew: false,
        };
    },

    DESIGNER_SAVE_FAILURE(state: State, action: DesignerSaveFailureAction) {
        return {
            ...state,
            saving: false,
            error: action.payload,
        };
    },

    DESIGNER_CANCEL(state: State, action: DesignerCancelAction) {
        return {
            ...state,
            saving: false,
            error: null,
        };
    },


    //
    // Shell Actions
    //

    LOGOUT(state: State, action: LogoutAction) {
        return initialState;
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/designerReducer.ts